import { defineStore } from 'pinia';
import axios from 'axios';

/**
 * Reduce a given array of object to specific properties
 */

function selectProps(...props) {
  // eslint-disable-next-line func-names
  return function (obj) {
    const newObj = {};
    props.forEach((name) => {
      newObj[name] = obj[name];
    });
    return newObj;
  };
}

export const useDeliveryStore = defineStore('delivery', {
  state: () => ({
    deliveries: [],
    days: [],
    selectedDelivery: '',
    selectedDay: '',
  }),
  getters: {
    getDeliveries() {
      return this.deliveries;
    },
    getDays() {
      return this.days;
    },
  },
  actions: {
    async getDeliveriesAndDays(number) {
      const params = new URLSearchParams([
        ['number', number],
      ]);
      const locationData = await axios.get(`${window.app.pnpform.api_base}location.json`, { params });
      const deliveryData = locationData.data.map(selectProps('reference', 'id', 'productIdentifier'));
      const dayData = locationData.data.map(selectProps('schedule', 'id'));

      this.$patch({
        deliveries: deliveryData,
        days: dayData,
      });
    },
  },
});
